import {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';

import {selectTypes} from '../../features/types.slice';
import {types as defaultTypes} from '../../utils/settings';

import styles from '../../styles/base_components/Icon.module.scss';

/**
 * @param props.type {string}
 */
function Icon(props) {
  const pRef = useRef(null);
  // const imgRef = useRef(null);
  // const [imgWidth, setImgWidth] = useState();
  // const [imgHeight, setImgHeight] = useState();
  const [width, setWidth] = useState('50px');
  const userTypes = useSelector(selectTypes);

  useEffect(() => {
    if (!pRef.current) return;

    const textWidth = pRef.current && pRef.current.offsetWidth;
    if (textWidth > 50) setWidth(textWidth + 'px');
  }, [pRef.current?.offsetWidth]);

  // useEffect(() => {
  //   if (!imgRef.current) return;

  //   const width = imgRef.current.clientWidth;
  //   const height = imgRef.current.clientHeight;
  //   if (width >= height) {
  //     imgRef.current.clientWidth = '40px';
  //     setImgWidth(40);
  //   }
  //   if (width <= height) {
  //     imgRef.current.clientHeight = '40px';
  //     setImgHeight(40);
  //   }
  // }, []);

  return (
    <div className={styles.icon} style={{width: width}}>
      <div>
        <img src={defaultTypes[props.type]?.inactive || userTypes[props.type]?.inactive || defaultTypes['default'].inactive} alt={props.type}/>
      </div>
      <div>
        <p ref={pRef}>{defaultTypes[props.type]?.name || userTypes[props.type]?.name || props.type}</p>
      </div>
    </div>
  );
}

export default Icon;